import React, {Component} from 'react'

import styled from '@emotion/styled'
import sv from '../styles/marketing'
import AuthBase from '../components/AuthBase'
import AuthButton from '../components/AuthButton'
import AuthError from '../components/AuthError'
import AuthFormField from '../components/AuthFormField'

import {connect} from 'react-redux';

import {alertActions, userActions} from '../_actions';

import {withTranslation} from "react-i18next";
import {AnimatedLoader, Container, StyledMedia} from "../styles/CommonStyler";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {alertActionTypes} from "../_constants";
import {isMobileOnly} from "react-device-detect";
import {authenticationState} from "../_constants/commons/authenticationState";

// STYLE ##########################################################

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
`;

const Options = styled(`div`)`
  ${sv.label};
  text-transform: none;
  margin-top: 24px;
  ${sv.flexCenter};
`;

const OptionLink = styled(`div`)`
  color: ${sv.colors.body};
  cursor: pointer;
`;

// COMPONENT ##########################################################

class SignIn extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.signIn = this.signIn.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        const {t} = this.props;
        const { username, password } = this.state;

        if (username && password) {
            this.signIn(username, password);
        } else {
            this.props.dispatchEmptyFieldError({ "errorMsg" : t("The email or password seems to be empty")} );
        }
    }

    signIn(username, password) {
        this.props.login(username, password);
    }

    render() {
        const {alert, t, authentication} = this.props;
        const isSigningIn = authentication.authState === authenticationState.LOGGING_IN;
        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header/>

                    <AuthBase title={t('Sign in to Gistify.')}>
                        {
                            alert.type === alertActionTypes.ERROR && !isSigningIn &&
                            <AuthError error={alert.message.errorMsg}/>
                        }
                        <AuthFormField
                            label='Email'
                            placeholder='bob@smith.com'
                            update={this.handleChange}
                            name="username"
                            onEnterPressed={this.handleSubmit}
                            disabled={isSigningIn}
                        />
                        <AuthFormField
                            password
                            label='Password'
                            placeholder={t('Enter password')}
                            update={this.handleChange}
                            name="password"
                            onEnterPressed={this.handleSubmit}
                            disabled={isSigningIn}
                        />
                        <Actions>
                            {/* when not signing in */}
                            { !isSigningIn &&
                            <>
                                <AuthButton onClick={this.handleSubmit} id="submit">{t('Sign In')}</AuthButton>
                            </>
                            }

                            {/* when signing in */}
                            { isSigningIn &&
                            <>
                                <AuthButton onClick={this.handleSubmit} id="submit"><AnimatedLoader color={sv.colors.light} /></AuthButton>
                            </>
                            }
                        </Actions>
                        <Options>
                            <OptionLink onClick={() => this.props.history.push('/password/forgot')}>{t('Forgot Password?')}</OptionLink>
                        </Options>
                        <Options>
                            <OptionLink onClick={() => this.props.history.push('/signup')}>{t('Create an account')}</OptionLink>
                        </Options>
                    </AuthBase>

                    <Footer />

                </Container>
            </StyledMedia>
        )
    }
}

function mapStateToProps(state) {
    const { authentication, alert } = state;
    return {
        authentication, alert
    };
}

function mapDispatchToProps(dispatch) {
    return {
        login: (username, password)     => dispatch( userActions.login(username, password) ),
        dispatchEmptyFieldError: (msg)  => dispatch( alertActions.error(msg) )
    }
}

const connectedSignIn = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SignIn));
export { connectedSignIn as SignIn };
